import { IPermitCode } from '../types';
import { HydraQueryParams, useHydraQuery } from './useHydraQuery';

export function useGetPermitCodesQuery<D extends IPermitCode[]>(params?: HydraQueryParams<D>) {
  const { vars, options, key } = params || {};

  return useHydraQuery<D>(key ?? `getPermitCodesQuery`, `/api/permit_codes?pagination=false`, {
    vars,
    options,
  });
}
